module.exports = __webpack_public_path__ + "static/media/ben-berwers-oaKDSL1knuE-unsplash.2d97fb28.jpg";